/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
*/

import type { SVGProps } from 'react'

// Untitled UI Icons — "message-text-square-01" (Line variant). Rounded
// square chat bubble with a downward tail at the bottom-left and two
// horizontal text lines inside. Stroked to inherit colour + stroke-width
// from the Icon parent (same pattern as `Inbox` / `ArrowLeft`).
const MessageTextSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.75}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8 9h8" />
    <path d="M8 12.5h5.5" />
    <path d="M11.444 21l-1.446-1.999H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4l-1.555 2.001Z" />
  </svg>
)

export default MessageTextSquare
